import { lazy, Suspense, useState, useCallback } from 'react';
import { CUSTOM_MESSAGES } from '@veriables';
import store from '@store';
import { setIsTipOnlyEnabled } from '@reducers/storeChecks';
import {
  useSubmitTabName,
  useValidateTabName,
  useGoToOrderFromSearch,
} from '../header/headerHandler';

const OpenTabCheckModal = lazy(() =>
  import('@components/storeChecks/Modals/OpenTabCheck')
);
const AddTabModalComponent = lazy(() =>
  import('@components/storeChecks/Modals/AddTabModal')
);
const ExistingCheckModal = lazy(() =>
  import('@containers/StoreChecks/Modals/ExistingCheckModal')
);

export const useTabModal = ({
  serverAppTheme,
  orderingPortraitOrientation,
  deviceGroup,
  tableData,
  pageNo,
  deviceInfo,
  setErrorPopUp,
  authCountry,
  isTipOnlyEnabled,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tabValue, setTabValue] = useState(null);
  const [tabCheckModelOpen, setTabCheckModelOpen] = useState(false);
  const [countryCode, setCountryCode] = useState(authCountry ?? 1);
  const [phoneNumberMaxLength, setPhoneNumberMaxLength] = useState(
    authCountry === 1 ? 10 : 15
  );

  const onOpenTab = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    if (isTipOnlyEnabled) {
      store.dispatch(setIsTipOnlyEnabled(false));
    }
  }, [isTipOnlyEnabled]);
  const onTabOpen = useCallback(data => {
    setIsModalOpen(false);
    setTabValue(data);
    setTabCheckModelOpen(true);
  }, []);
  const handleCountryCodeChange = useCallback(event => {
    setPhoneNumberMaxLength(Number(event.id) !== 1 ? 15 : 10);
    setCountryCode(event.id);
  }, []);
  
  const order = useGoToOrderFromSearch();
  const handleGoToOrder = useCallback((isCheck) => {
    setIsModalOpen(false);
    order(isCheck);
  }, [order]);

  const submitTabName = useSubmitTabName(countryCode);
  const validateTabName = useValidateTabName({
    onTabOpen,
    onGoToOrder: handleGoToOrder,
  });

  const jsx = (
    <>
      {isModalOpen && (
        <Suspense fallback={null}>
          <OpenTabCheckModal
            isModalOpen={isModalOpen}
            serverAppTheme={serverAppTheme}
            isTipOnlyEnabled={isTipOnlyEnabled}
          >
            <AddTabModalComponent
              name="tabName"
              placeholder={CUSTOM_MESSAGES().ENTER_TAB_NAME}
              validate={validateTabName}
              onSubmit={submitTabName}
              orderingPortraitOrientation={orderingPortraitOrientation}
              deviceGroup={deviceGroup}
              serverAppTheme={serverAppTheme}
              onCloseTable={closeModal}
              setErrorPopUp={setErrorPopUp}
              countryCode={countryCode}
              handleCountryCodeChange={handleCountryCodeChange}
              phoneNumberMaxLength={phoneNumberMaxLength}
              isOpen={isModalOpen}
              isTipOnlyEnabled={isTipOnlyEnabled}
            />
          </OpenTabCheckModal>
        </Suspense>
      )}

      {tabCheckModelOpen && (
        <Suspense fallback={null}>
          <ExistingCheckModal
            checkModelOpen={tabCheckModelOpen}
            setCheckModelOpen={setTabCheckModelOpen}
            isTableValue={tabValue}
            serverAppTheme={serverAppTheme}
            setIsOpenCheck={() => { }}
            setIsModalOpen={setIsModalOpen}
            submitTableNumber={submitTabName}
            goToOrder={order}
            tableData={tableData}
            pageNo={pageNo}
            deviceInfo={deviceInfo}
          />
        </Suspense>
      )}
    </>
  );

  return { onOpenTab, jsx };
};
